import { isNil } from '@lucidlink/tscore';
export const createErrorHandler = (requiredError, formatError) => (issue) => isNil(issue.input) ? requiredError : formatError;
